"use client";
import { styled } from "@mui/material/styles";
import { SpaceXs, FontSize200 } from "@nxt-costco-com/forge-design-tokens";
const StyledLabel = styled("label")({
  "&:hover": {
    cursor: "pointer"
  },
  alignItems: "flex-start",
  display: "flex",
  fontSize: FontSize200,
  gap: SpaceXs,
  lineHeight: "21px",
  marginLeft: SpaceXs
});
export {
  StyledLabel
};
